export default function sampleAxiosReducer(state=[], action) {
    switch(action.type){
        case "test_type": {
            return action.payload
        }
        default: {
            return state
        }
    }
}